import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClinicalNoteApi } from '../../../apis/ClinicalNoteApi/ClinicalNoteApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { ClinicalNoteType } from '../ClinicalNote';

export function useDeleteClinicalNote(noteType: ClinicalNoteType, _i18nPrefix: string, patientId?: string | number) {
    const queryClient = useQueryClient();

    return useMutation<string, AppMedError, string>({
        mutationKey: [QueryKeys.clinicalNotes, noteType, 'delete'],
        mutationFn: async (id: string) => {
            await ClinicalNoteApi.deleteClinicalNote(id);
            return id;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicalNotes, noteType] });
            if (patientId != null)
                queryClient.invalidateQueries({ queryKey: [QueryKeys.clinicalNoteActivity, noteType, String(patientId)] });
        },
    });
}
